import { Countries, Currencies, DistanceUnit, IntlSettings, Locales } from '@grandvisionhq/state'

export const INTL_DEFAULTS: IntlSettings = {
  country: Countries.NL,
  locale: Locales['nl-NL'],
  currency: Currencies.EUR,
  distanceUnit: DistanceUnit.km,
  dateFormat: {
    long: 'EEEE d MMMM yyyy',
    midsize: 'dd MMMM yyyy',
    narrow: 'd MMMM', // 6 maart
    short: 'dd/MM/yyyy',
  },
}

type PossibleLocales = keyof Pick<typeof Locales, 'nl-NL'>

export const intlConfigMap: {
  [L in PossibleLocales]: IntlSettings
} = {
  'nl-NL': INTL_DEFAULTS,
}
